<template>
	<div>
		<price-details
			:in-tab="true"
			:tariffs="
				resultItem.ComparisonTabs
					? resultItem.ComparisonTabs.ComparisonTabPrice
					: resultItem.PriceDetail.TariffTable
			"
		></price-details>
		<template v-if="receipt">
			<p v-if="receipt.Intro">{{ receipt.Intro }}</p>
			<key-value-label v-if="receipt.Delivery[0]" :data="receipt.Delivery[0]" />
			<key-value-label v-if="receipt.Delivery[1]" :data="receipt.Delivery[1]" />
			<key-value-label
				v-if="receipt.SubTotal"
				:sharedClass="'u-weight--bold pt'"
				:valueClass="'u-border--top '"
				:is-semi-total="true"
				:data="receipt.SubTotal[0]"
			/>

			<key-value-label
				v-if="receipt.SubTotal && receipt.SubTotal[1]"
				:sharedClass="'zeta u-text-color-status--green'"
				:extra-text="receipt.SubTotal[1].ToolTip"
				:data="receipt.SubTotal[1]"
			/>
			<key-value-label
				v-if="receipt.Total && receipt.Total[0] && receipt.Total[0].Text"
				:data="receipt.Total[0]"
				:is-total="true"
				:valueClass="'u-border--top pt-'"
				:sharedClass="' mt u-weight--bold pt-'"
			/>
			<div class="u-text-color-grey u-text-align--right">
				Indicatie maandelijks termijnbedrag (indicatief excl. eventuele korting):
				{{ resultItem.TotalExpensesMonth.Unit }} {{ resultItem.TotalExpensesMonth.Value }}.
			</div>

			<span class="mv- u-display--inline-block"></span>
			<template v-if="isDetail">
				<redelivery-calculation
					:delivery-detail="resultItem.DeliveryDetail"
					v-if="resultItem.DeliveryDetail"
				></redelivery-calculation>
				<energy-type-price-detail
					:energyType="'Stroom'"
					v-if="priceDetail.Electricity"
					:defaultOpen="isDetail"
					:deliveryDetail="resultItem.DeliveryDetail"
					:supplierName="resultItem.SupplierName"
					:networkAdministrator="
						resultItem.AddressInfo ? resultItem.AddressInfo.NetworkAdministratorElectricity : ''
					"
					:energyItemPriceDetails="priceDetail.Electricity"
				/>
				<energy-type-price-detail
					:energyType="'Gas'"
					:defaultOpen="isDetail"
					v-if="priceDetail.Gas"
					:supplierName="resultItem.SupplierName"
					:networkAdministrator="resultItem.AddressInfo ? resultItem.AddressInfo.NetworkAdministratorGas : ''"
					:energyItemPriceDetails="priceDetail.Gas"
				/>
			</template>
		</template>
	</div>
</template>

<script>
import KeyValueLabel from './KeyValueLabel';
import EnergyTypePriceDetail from './EnergyTypePriceDetail';
import PriceDetails from './PriceDetails';
import RedeliveryCalculation from './RedeliveryCalculation';
export default {
	props: ['resultItem', 'address', 'comparisonTabPrice', 'isDetail'],
	components: {
		KeyValueLabel,
		EnergyTypePriceDetail,
		PriceDetails,
		RedeliveryCalculation,
	},
	mounted() {},
	computed: {
		priceDetail: function () {
			return this.resultItem.PriceDetail;
		},
		receipt: function () {
			return this.resultItem.PriceDetail ? this.resultItem.PriceDetail.Receipt : {};
		},
	},
};
</script>
